import React, { useState, useEffect } from 'react'
import { getTextById } from '../../../../api/text';
import { alertError } from '../../../../utils';

function PrivatePolicyPage() {
	const [privatePolicy, setPrivatePolicy] = useState(null);

	useEffect(() => {
		getTextById("63ca91bcd2ef4fae741f9566")
			.then((res) => {
				setPrivatePolicy(res.data);
			})
			.catch((error) => {
				alertError({error, customMessage: "Could not get privacy policy."})
			})
	}, [])

  	return (
		<div style={{ padding: 100, textAlign: 'left' }}>
			<h1>Política de privacidad</h1>
			<div 
				style={{ fontSize: 16, lineHeight: 1.6 }}
				dangerouslySetInnerHTML={{
					__html: privatePolicy?.content?.es || ''
				}}
			/>
		</div>
	)
}

export default PrivatePolicyPage
